import React from 'react';
import styles from './LoadingIndicator.module.sass';

const LoadingIndicator = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles['loading-container']} ${className}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['loading-indicator']
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null)));
};

export default LoadingIndicator;